import styled from '@emotion/styled';

export default styled.textarea`
  color: ${({ theme }) => theme.colors.greyNotes};
  box-shadow: 0 3px 6px 0 ${({theme}) => theme.colors.colorlessBoxShadow};
  padding: 11px 12px;
  margin-bottom: 16px;
  min-height: 50px;
  width: 100%;
  height: 119px;
  border: none;
  background-color: ${({ordersNotes, theme})=> ordersNotes ? theme.colors.yellow : 'white' };
`;
